import type { Candidate } from '../repository'

import cardProductMeta from '@cogo/schema/blocks-v2/card/card-product/block.cogo.json'
import cardProductUi from '@cogo/schema/blocks-v2/card/card-product/ui.cogo.json'
import cardProductEvents from '@cogo/schema/blocks-v2/card/card-product/events.cogo.json'
import cardProductFlow from '@cogo/schema/blocks-v2/card/card-product/flow.cogo.json'
import cardProductVariables from '@cogo/schema/blocks-v2/card/card-product/variables.cogo.json'
import cardProductDatasource from '@cogo/schema/blocks-v2/card/card-product/datasource.cogo.json'
import { cloneBlockDef, appendRootClassName } from './util'

function buildBaseCard() {
  return cloneBlockDef({
    meta: cardProductMeta,
    ui: cardProductUi,
    events: cardProductEvents,
    flow: cardProductFlow,
    state: cardProductVariables,
    data: cardProductDatasource,
  })
}

export const dsAxisCandidates: Candidate[] = [
  {
    id: 'ds-axis-a',
    exampleId: 'cexample:card-product-ds-shadcn',
    patternId: 'cpat:product-card-grid',
    dsId: 'ds:shadcn',
    // shadcn-native rendering — no extra class needed
    cogoJson: buildBaseCard(),
    narrativeHeadline: 'Product card · shadcn/ui token set',
    dsCompatibility: 'exact',
    score: 90,
  },
  {
    id: 'ds-axis-b',
    exampleId: 'cexample:card-product-ds-tailwind-ui',
    patternId: 'cpat:product-card-grid',
    dsId: 'ds:tailwind-ui',
    // subtle accent ring to signal Tailwind UI token override
    cogoJson: appendRootClassName(buildBaseCard(), 'ring-2 ring-primary/40'),
    narrativeHeadline: 'Product card · Tailwind UI token set',
    dsCompatibility: 'adjacent',
    score: 80,
  },
  {
    id: 'ds-axis-c',
    exampleId: 'cexample:card-product-ds-radix',
    patternId: 'cpat:product-card-grid',
    dsId: 'ds:radix',
    // visible border swap to signal Radix primitives token override
    cogoJson: appendRootClassName(buildBaseCard(), 'border-2 border-accent'),
    narrativeHeadline: 'Product card · Radix primitives token set',
    dsCompatibility: 'cross',
    score: 70,
  },
]
